import { Stack, Typography } from '@mui/material';
import { DATE_TIME_FORMAT } from 'constants/date';
import { formatDate, formatPrice } from 'utils';

interface TransactionHistoryItemProps {
  txnTitle: string;
  mathSigns: '+' | '-';
  txnNumber: string;
  createdAt: string;
  totalAmount: number;
  remark?: string;
  paymentMethodType?: string;
  status: string;
}

export function TransactionHistoryItem({
  txnTitle,
  txnNumber,
  totalAmount,
  remark,
  mathSigns,
  createdAt,
  status,
  paymentMethodType,
}: TransactionHistoryItemProps) {
  return (
    <Stack
      padding={1}
      gap={0.5}
      sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: '1px solid #959595',
        borderRadius: 2,
      }}
    >
      <Stack spacing={0.5}>
        <Typography fontSize={15} fontWeight={600}>
          {txnNumber}
        </Typography>
        <Typography fontSize={15} fontWeight={600}>
          Txn Title:&nbsp;
          <Typography component={'span'} fontSize={14} fontWeight={400}>
            {txnTitle}
          </Typography>
        </Typography>

        <Typography fontSize={15} fontWeight={600}>
          Date Time:&nbsp;
          <Typography component={'span'} fontSize={14} fontWeight={400}>
            {formatDate(createdAt, {
              format: DATE_TIME_FORMAT.GENERAL,
            })}
          </Typography>
          {/* {startDateTime && end_datetime
            ? `- ${formatDate(startDateTime, {
                format: 'hh:mm A',
              })} to ${formatDate(end_datetime, { format: 'hh:mm A' })}`
            : ''} */}
        </Typography>
        <Typography fontSize={15} fontWeight={600}>
          Remark:&nbsp;
          <Typography component={'span'} fontSize={14} fontWeight={400}>
            {remark ?? 'None'}
          </Typography>
        </Typography>
        <Typography fontSize={15} fontWeight={600}>
          Payment method:&nbsp;
          <Typography component={'span'} fontSize={14} fontWeight={400}>
            {paymentMethodType === 'card'
              ? 'Card'
              : paymentMethodType === 'aunty_credit'
              ? 'Aunty Credit'
              : 'PayNow'}
          </Typography>
        </Typography>
      </Stack>

      <Stack direction={'row'} alignItems={'center'} gap={0.75}>
        <Typography fontSize={18} fontWeight={700} color={'primary.main'}>
          {mathSigns === '+' ? '-' : '+'}
          {formatPrice(totalAmount)}
        </Typography>
        <Stack
          sx={{
            width: '9px',
            height: '9px',
            borderRadius: '50%',
            marginBottom: '5px',
            backgroundColor: status === 'success' ? 'green.light' : 'red.light',
          }}
        />
      </Stack>
    </Stack>
  );
}

export default TransactionHistoryItem;
